export const translations = {
  en: {
    app: {
      title: "LandFalken",
      subtitle: "Intelligent site scouting",
      mySites: "My Sites",
      signIn: "Sign In"
    },
    siteScreener: {
      title: "Site Screener",
      loadingGrid: "Loading grid connections...",
      selectLocation: "Select a location on the map",
      searchPlaceholder: "Search for a location...",
      zones: "Zones",
      municipalities: "Municipalities",
      voltage: "Voltage",
      distance: "Distance",
      operator: "Operator",
      availableCapacity: "Available Capacity",
      priceZone: "Price Zone",
      lcohLegend: "LCOH indication",
      lcohDisclaimer: "*Rough estimate ±30%",
      showLcohMap: "Show LCOH map",
      drawMode: "Draw mode",
      endDrawMode: "End draw mode",
      drawPolygon: "Draw site polygon",
      draw: "Draw",
      drawnArea: "Drawn area",
      zoomIn: "Zoom in to see parcels",
      zoomPrompt: "Zoom to level 12 or higher to see available parcels in this area",
      loadingParcels: "Loading parcels...",
      checkingZones: "Checking zones for {count} parcels...",
      parcelsFound: "{count} parcels found"
    },
    siteFinder: {
      title: "Find optimal sites",
      searchPlaceholder: "Search municipality number or name…",
      loading: "Loading municipalities...",
      noResults: "No municipalities found",
      zones: "Zones",
      searching: "Searching...",
      regionSelected: "✓ Region selected — searching in current map view",
      regionWarning: "⚠ Pan/zoom map to define region",
      visibleRegion: "Visible region",
      currentMapView: "Current map view",
      allNorway: "All Norway",
      areaRequired: "Area required",
      water: "Water",
      necessary: "necessary",
      searchArea: "Search Area",
      project: "Project",
      technology: "Technology",
      capacity: "Capacity",
      buffer: "Buffer",
      seawaterAccess: "Seawater access",
      requiredVoltage: "Required voltage",
      filters: "Filters",
      maxGridDistance: "Max grid distance",
      minVoltageLevel: "Min. voltage level",
      protectedDistance: "Protected distance",
      portDistance: "Port distance",
      portDepth: "Port depth",
      waterDistance: "Water distance",
      terrain: "Terrain",
      maxElevation: "Max elevation",
      maxSlope: "Max slope",
      advancedFilters: "Advanced filters",
      active: "active",
      hazardRisk: "Landslide & flood risk",
      biodiversity: "Biodiversity",
      all: "All",
      noFilter: "No filter",
      simple: "Simple",
      excludeOverlapping: "Excl. overlapping zones",
      safe: "Safe",
      fromZones: "from zones",
      strict: "Strict",
      noneWithin: "None within",
      searchButton: "Search",
      stopSearch: "Stop",
      selected: "selected",
      sortBy: "Sort by",
      score: "Score",
      gridDistance: "Grid distance",
      area: "Area",
      results: "Results",
      noResultsFound: "No results found",
      selectAtLeastOne: "Select at least one municipality, or use 'Visible region' on the map",
      roadAccess: "Road access",
      roadQuality: "Road quality",
      bridgeCapacity: "Bridge capacity",
      buildSeason: "Build season",
      frostFreeMonths: "Build season (frost-free months/year)",
      waterRights: "Water rights",
      noSalmon: "No salmon",
      excludeSalmonRivers: "Excl. salmon rivers",
      lowConflict: "Low conflict",
      noEndangered: "No endangered species",
      noRedListed: "No red-listed",
      municipalRoad: "Municipal road",
      municipalOrBetter: "Municipal or better",
      countyRoad: "County road",
      countyOrBetter: "County or better",
      nationalRoad: "E / Rv",
      nationalOnly: "National road only",
      notChecked: "Not checked",
      pavedRoads: "Paved roads",
      electrolyzerDelivery: "Electrolyzer delivery",
      heavyTransport: "Transformers/heavy transport",
      inland: "Inland / north",
      midNorway: "Mid-Norway",
      coastSouth: "Coast / south",
      months: "months",
      oneKmFromZones: "≥1 km from zones",
      noneWithin2km: "None within 2 km",
      protectionPlan: "Protection plan",
      excludeProtectedWaters: "Excl. protected waters",
      noHydroCompetition: "+ no hydro competition",
      selectStation: "Select station",
      findZones: "Find sites",
      findStations: "Find stations",
      candidatesFound: "candidates found",
      radius: "Radius",
      suitableSitesFound: "suitable sites found",
      gridConnectionsFound: "grid connections found",
      zoomToSeeParcels: "Zoom in on the map to see and select parcels",
      candidate: "Candidate",
      unknownStation: "Unknown station",
      searchFailed: "Search failed",
      analyzing: "Analyzing parcels",
      fetchingData: "Fetching analysis data",
      complete: "Complete",
      noSitesLargeEnough: "No parcels were large enough or in suitable zone within search radius.",
      noSitesMatchedCriteria: "No parcels matched all criteria.",
      sitesBlockedByHardStop: "parcels reached analysis, but were blocked by hard stops.",
      tryIncreaseDistance: "Try increasing grid distance, lowering voltage requirement, or searching in a different area."
    },
    mapControls: {
      changeMapStyle: "Change map style",
      layers: "Layers",
      mapStyle: "Map style",
      wmsLayers: "WMS layers",
      showAll: "Show all",
      hideAll: "Hide all",
      critical: "Critical",
      additional: "Additional"
    },
    analysis: {
      noAnalysisAvailable: "No concession analysis available",
      runAnalysisHint: "Click 'Run concession assessment' to evaluate approval probability",
      disclaimer: "This assessment is based on regulatory analysis and historical data. Actual approval probability may vary. Consult with legal experts and regulatory authorities.",
      loading: "Loading...",
      gridCapex: "Grid CAPEX",
      waterAssessment: "Water Assessment",
      lcohCalculator: "LCOH Calculator",
      costEstimate: "Cost Estimate",
      conceptComparison: "Concept Comparison"
    },
    common: {
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      search: "Search",
      select: "Select",
      clear: "Clear",
      back: "Back",
      next: "Next",
      previous: "Previous",
      done: "Done",
      edit: "Edit",
      delete: "Delete",
      add: "Add",
      remove: "Remove",
      selected: "selected",
      municipality: "Municipality"
    }
  },
  no: {
    app: {
      title: "LandFalken",
      subtitle: "Intelligent stedsletting",
      mySites: "Mine Steder",
      signIn: "Logg Inn"
    },
    siteScreener: {
      title: "Stedsscreener",
      loadingGrid: "Laster nettforbindelser...",
      selectLocation: "Velg et sted på kartet",
      searchPlaceholder: "Søk etter et sted...",
      zones: "Soner",
      municipalities: "Kommuner",
      voltage: "Spenning",
      distance: "Avstand",
      operator: "Operatør",
      availableCapacity: "Tilgjengelig Kapasitet",
      priceZone: "Prisområde",
      lcohLegend: "LCOH indikasjon",
      lcohDisclaimer: "*Grov estimat ±30%",
      showLcohMap: "Vis LCOH-kart",
      drawMode: "Tegnmodus",
      endDrawMode: "Avslutt tegnmodus",
      drawPolygon: "Tegn tomtepolygon",
      draw: "Tegn",
      drawnArea: "Tegnet areal",
      zoomIn: "Zoom inn for å se teiger",
      zoomPrompt: "Zoom inn til nivå 12 eller høyere for å se tilgjengelige tomter i dette området",
      loadingParcels: "Laster teiger...",
      checkingZones: "Sjekker soner for {count} teiger...",
      parcelsFound: "{count} teiger funnet"
    },
    siteFinder: {
      title: "Finn egnede tomter",
      searchPlaceholder: "Søk kommunenummer eller navn…",
      loading: "Laster kommuner...",
      noResults: "Ingen kommuner funnet",
      zones: "Soner",
      searching: "Søker...",
      regionSelected: "✓ Region valgt — søker i gjeldende kartvisning",
      regionWarning: "⚠ Panorér/zoom kartet for å definere region",
      visibleRegion: "Synlig region",
      currentMapView: "Gjeldende kartvisning",
      allNorway: "Hele Norge",
      areaRequired: "Areal nødvendig",
      water: "Vann",
      necessary: "nødvendig",
      searchArea: "Søkeområde",
      project: "Prosjekt",
      technology: "Teknologi",
      capacity: "Kapasitet",
      buffer: "Buffer",
      seawaterAccess: "Sjøvanntilgang",
      requiredVoltage: "Nødvendig spenning",
      filters: "Filtre",
      maxGridDistance: "Maks netavstand",
      minVoltageLevel: "Min. spenningsnivå",
      protectedDistance: "Verneavstand",
      portDistance: "Havneavstand",
      portDepth: "Havnedybde",
      waterDistance: "Vannavstand",
      terrain: "Terreng",
      maxElevation: "Maks høyde",
      maxSlope: "Maks helning",
      advancedFilters: "Avanserte filtre",
      active: "aktive",
      hazardRisk: "Skred- og flomrisiko",
      biodiversity: "Biologisk mangfold",
      all: "Alle",
      noFilter: "Ingen filter",
      simple: "Enkel",
      excludeOverlapping: "Ekskl. overlappende soner",
      safe: "Trygg",
      fromZones: "fra soner",
      strict: "Streng",
      noneWithin: "Ingen innen",
      searchButton: "Søk",
      stopSearch: "Stopp",
      selected: "valgt",
      sortBy: "Sorter etter",
      score: "Poengsum",
      gridDistance: "Nettavstand",
      area: "Areal",
      results: "Resultater",
      noResultsFound: "Ingen resultater funnet",
      selectAtLeastOne: "Velg minst én kommune, eller bruk 'Synlig region' på kartet",
      roadAccess: "Veiadkomst",
      roadQuality: "Veikvalitet",
      bridgeCapacity: "Brokapasitet",
      buildSeason: "Byggesong",
      frostFreeMonths: "Byggesong (frostfrie mnd/år)",
      waterRights: "Vannrettigheter",
      noSalmon: "Ingen laks",
      excludeSalmonRivers: "Ekskl. lakseelver",
      lowConflict: "Lav konflikt",
      noEndangered: "Ingen truede arter",
      noRedListed: "Ingen rødlistede",
      municipalRoad: "Kommunevei",
      municipalOrBetter: "Kommunal eller bedre",
      countyRoad: "Fylkesvei",
      countyOrBetter: "Fylkes eller bedre",
      nationalRoad: "E / Rv",
      nationalOnly: "Kun riksvei",
      notChecked: "Ikke sjekket",
      pavedRoads: "Asfalterte veier",
      electrolyzerDelivery: "Elektrolyserleveranse",
      heavyTransport: "Transformatorer/tungtransport",
      inland: "Innlandet / nord",
      midNorway: "Midt-Norge",
      coastSouth: "Kyst / sør",
      months: "mnd",
      oneKmFromZones: "≥1 km fra soner",
      noneWithin2km: "Ingen innen 2 km",
      protectionPlan: "Verneplan",
      excludeProtectedWaters: "Ekskl. vernede vassdrag",
      noHydroCompetition: "+ ingen vannkraftkonkurranse",
      selectStation: "Velg stasjon",
      findZones: "Finn tomter",
      findStations: "Finn stasjoner",
      candidatesFound: "kandidater funnet",
      radius: "Radius",
      suitableSitesFound: "egnede tomter funnet",
      gridConnectionsFound: "nettilkoblingspunkter funnet",
      zoomToSeeParcels: "Zoom inn på kartet for å se og velge tomter (teiger)",
      candidate: "Kandidat",
      unknownStation: "Ukjent stasjon",
      searchFailed: "Søk feilet",
      analyzing: "Analyserer tomter",
      fetchingData: "Henter analysedata",
      complete: "Ferdig",
      kartutsnitt: "Kartutsnitt",
      noSitesLargeEnough: "Ingen tomter var store nok eller i egnet sone innenfor søkeradius.",
      noSitesMatchedCriteria: "Ingen tomter matchet alle kriterier.",
      sitesBlockedByHardStop: "tomter nådde analysen, men ble blokkert av harde stopp.",
      tryIncreaseDistance: "Prøv å øke nettavstand, senk spenningskrav, eller søk i et annet område."
    },
    mapControls: {
      changeMapStyle: "Endre kartstil",
      layers: "Kartlag",
      mapStyle: "Kartstil",
      wmsLayers: "WMS-kartlag",
      showAll: "Vis alt",
      hideAll: "Skjul alt",
      critical: "Kritiske",
      additional: "Tillegg"
    },
    analysis: {
      noAnalysisAvailable: "Ingen konsesjonsanalyse tilgjengelig",
      runAnalysisHint: "Klikk «Kjør konsesjonsvurdering» for å vurdere godkjenningssannsynlighet",
      disclaimer: "Denne vurderingen er basert på regulatorisk analyse og historiske data. Faktisk godkjenningssannsynlighet kan variere. Konsulter med juridiske eksperter og reguleringsmyndigheter.",
      loading: "Laster...",
      gridCapex: "Nett CAPEX",
      waterAssessment: "Vannvurdering",
      lcohCalculator: "LCOH Kalkulator",
      costEstimate: "Kostnadsestimat",
      conceptComparison: "Konseptsammenligning"
    },
    common: {
      save: "Lagre",
      cancel: "Avbryt",
      confirm: "Bekreft",
      close: "Lukk",
      loading: "Laster...",
      error: "Feil",
      success: "Vellykket",
      search: "Søk",
      select: "Velg",
      clear: "Tøm",
      back: "Tilbake",
      next: "Neste",
      previous: "Forrige",
      done: "Ferdig",
      edit: "Rediger",
      delete: "Slett",
      add: "Legg til",
      remove: "Fjern",
      selected: "valgt",
      municipality: "Kommune"
    }
  },
  de: {
    app: {
      title: "LandFalken",
      subtitle: "Intelligente Standortsuche",
      mySites: "Meine Standorte",
      signIn: "Anmelden"
    },
    siteScreener: {
      title: "Standort-Screener",
      loadingGrid: "Netzanschlüsse werden geladen...",
      selectLocation: "Wählen Sie einen Standort auf der Karte",
      searchPlaceholder: "Nach einem Standort suchen...",
      zones: "Zonen",
      municipalities: "Gemeinden",
      voltage: "Spannung",
      distance: "Entfernung",
      operator: "Betreiber",
      availableCapacity: "Verfügbare Kapazität",
      priceZone: "Preiszone",
      lcohLegend: "LCOH Indikation",
      lcohDisclaimer: "*Grobe Schätzung ±30%",
      showLcohMap: "LCOH-Karte anzeigen",
      drawMode: "Zeichenmodus",
      endDrawMode: "Zeichenmodus beenden",
      drawPolygon: "Grundstück polygon zeichnen",
      draw: "Zeichnen",
      drawnArea: "Gezeichnete Fläche",
      zoomIn: "Hereinzoomen um Parzellen zu sehen",
      zoomPrompt: "Zoom auf Stufe 12 oder höher um verfügbare Parzellen in diesem Bereich zu sehen",
      loadingParcels: "Parzellen werden geladen...",
      checkingZones: "Zonen für {count} Parzellen werden überprüft...",
      parcelsFound: "{count} Parzellen gefunden"
    },
    siteFinder: {
      title: "Optimale Standorte finden",
      searchPlaceholder: "Gemeindenummer oder Name suchen…",
      loading: "Gemeinden werden geladen...",
      noResults: "Keine Gemeinden gefunden",
      zones: "Zonen",
      searching: "Suchen...",
      regionSelected: "✓ Region ausgewählt — Suche in aktueller Kartenansicht",
      regionWarning: "⚠ Karte bewegen/zoomen um Region zu definieren",
      visibleRegion: "Sichtbare Region",
      currentMapView: "Aktuelle Kartenansicht",
      allNorway: "Ganz Norwegen",
      areaRequired: "Fläche erforderlich",
      water: "Wasser",
      necessary: "erforderlich",
      searchArea: "Suchbereich",
      project: "Projekt",
      technology: "Technologie",
      capacity: "Kapazität",
      buffer: "Puffer",
      seawaterAccess: "Meerwasserzugang",
      requiredVoltage: "Erforderliche Spannung",
      filters: "Filter",
      maxGridDistance: "Max. Netzentfernung",
      minVoltageLevel: "Min. Spannungsniveau",
      protectedDistance: "Schutzabstand",
      portDistance: "Hafenentfernung",
      portDepth: "Hafentiefe",
      waterDistance: "Wasserentfernung",
      terrain: "Gelände",
      maxElevation: "Max. Höhe",
      maxSlope: "Max. Neigung",
      advancedFilters: "Erweiterte Filter",
      active: "aktiv",
      hazardRisk: "Erdrutsch- & Hochwasserrisiko",
      biodiversity: "Biodiversität",
      all: "Alle",
      noFilter: "Kein Filter",
      simple: "Einfach",
      excludeOverlapping: "Überlappende Zonen ausschließen",
      safe: "Sicher",
      fromZones: "von Zonen",
      strict: "Streng",
      noneWithin: "Keine innerhalb",
      searchButton: "Suchen",
      stopSearch: "Stopp",
      selected: "ausgewählt",
      sortBy: "Sortieren nach",
      score: "Punktzahl",
      gridDistance: "Netzentfernung",
      area: "Fläche",
      results: "Ergebnisse",
      noResultsFound: "Keine Ergebnisse gefunden",
      selectAtLeastOne: "Wählen Sie mindestens eine Gemeinde oder verwenden Sie 'Sichtbare Region' auf der Karte",
      roadAccess: "Straßenzugang",
      roadQuality: "Straßenqualität",
      bridgeCapacity: "Brückenkapazität",
      buildSeason: "Bausaison",
      frostFreeMonths: "Bausaison (frostfreie Monate/Jahr)",
      waterRights: "Wasserrechte",
      noSalmon: "Kein Lachs",
      excludeSalmonRivers: "Lachsflüsse ausschließen",
      lowConflict: "Geringer Konflikt",
      noEndangered: "Keine gefährdeten Arten",
      noRedListed: "Keine rote Liste",
      municipalRoad: "Gemeindestraße",
      municipalOrBetter: "Gemeinde oder besser",
      countyRoad: "Kreisstraße",
      countyOrBetter: "Kreis oder besser",
      nationalRoad: "E / Rv",
      nationalOnly: "Nur Bundesstraße",
      notChecked: "Nicht geprüft",
      pavedRoads: "Asphaltierte Straßen",
      electrolyzerDelivery: "Elektrolyseur-Lieferung",
      heavyTransport: "Transformatoren/Schwertransport",
      inland: "Inland / Norden",
      midNorway: "Mitte-Norwegen",
      coastSouth: "Küste / Süden",
      months: "Monate",
      oneKmFromZones: "≥1 km von Zonen",
      noneWithin2km: "Keine innerhalb 2 km",
      protectionPlan: "Schutzplan",
      excludeProtectedWaters: "Geschützte Gewässer ausschließen",
      noHydroCompetition: "+ keine Wasserkraftkonkurrenz",
      selectStation: "Station auswählen",
      findZones: "Standorte finden",
      findStations: "Stationen finden",
      candidatesFound: "Kandidaten gefunden",
      radius: "Radius",
      suitableSitesFound: "geeignete Standorte gefunden",
      gridConnectionsFound: "Netzanschlüsse gefunden",
      zoomToSeeParcels: "Zoomen Sie in die Karte, um Parzellen zu sehen und auszuwählen",
      candidate: "Kandidat",
      unknownStation: "Unbekannte Station",
      searchFailed: "Suche fehlgeschlagen",
      analyzing: "Parzellen analysieren",
      fetchingData: "Analysedaten abrufen",
      complete: "Fertig",
      noSitesLargeEnough: "Keine Parzellen waren groß genug oder in geeigneter Zone innerhalb des Suchradius.",
      noSitesMatchedCriteria: "Keine Parzellen erfüllten alle Kriterien.",
      sitesBlockedByHardStop: "Parzellen erreichten die Analyse, wurden aber durch harte Stopps blockiert.",
      tryIncreaseDistance: "Versuchen Sie, die Netzentfernung zu erhöhen, die Spannungsanforderung zu senken oder in einem anderen Bereich zu suchen."
    },
    mapControls: {
      changeMapStyle: "Kartenstil ändern",
      layers: "Kartenebenen",
      mapStyle: "Kartenstil",
      wmsLayers: "WMS-Kartenebenen",
      showAll: "Alle anzeigen",
      hideAll: "Alle ausblenden",
      critical: "Kritisch",
      additional: "Zusätzlich"
    },
    analysis: {
      noAnalysisAvailable: "Keine Konzessionsanalyse verfügbar",
      runAnalysisHint: "Klicken Sie 'Konzessionsbewertung durchführen' um Genehmigungswahrscheinlichkeit zu bewerten",
      disclaimer: "Diese Bewertung basiert auf regulatorischer Analyse und historischen Daten. Tatsächliche Genehmigungswahrscheinlichkeit kann variieren. Konsultieren Sie mit Rechtsexperten und Regulierungsbehörden.",
      loading: "Laden...",
      gridCapex: "Netz CAPEX",
      waterAssessment: "Wasserbewertung",
      lcohCalculator: "LCOH Rechner",
      costEstimate: "Kostenschätzung",
      conceptComparison: "Konzeptvergleich"
    },
    common: {
      save: "Speichern",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      close: "Schließen",
      loading: "Laden...",
      error: "Fehler",
      success: "Erfolg",
      search: "Suchen",
      select: "Auswählen",
      clear: "Löschen",
      back: "Zurück",
      next: "Weiter",
      previous: "Vorherige",
      done: "Fertig",
      edit: "Bearbeiten",
      delete: "Löschen",
      add: "Hinzufügen",
      remove: "Entfernen",
      selected: "ausgewählt",
      municipality: "Gemeinde"
    }
  },
  fr: {
    app: {
      title: "LandFalken",
      subtitle: "Recherche intelligente de sites",
      mySites: "Mes Sites",
      signIn: "Se Connecter"
    },
    siteScreener: {
      title: "Sélecteur de Site",
      loadingGrid: "Chargement des connexions réseau...",
      selectLocation: "Sélectionnez un emplacement sur la carte",
      searchPlaceholder: "Rechercher un emplacement...",
      zones: "Zones",
      municipalities: "Municipalités",
      voltage: "Tension",
      distance: "Distance",
      operator: "Opérateur",
      availableCapacity: "Capacité Disponible",
      priceZone: "Zone de Prix",
      lcohLegend: "Indication LCOH",
      lcohDisclaimer: "*Estimation approximative ±30%",
      showLcohMap: "Afficher la carte LCOH",
      drawMode: "Mode dessin",
      endDrawMode: "Terminer le mode dessin",
      drawPolygon: "Dessiner un polygone de site",
      draw: "Dessiner",
      drawnArea: "Zone dessinée",
      zoomIn: "Zoomer pour voir les parcelles",
      zoomPrompt: "Zoom au niveau 12 ou plus pour voir les parcelles disponibles dans cette zone",
      loadingParcels: "Chargement des parcelles...",
      checkingZones: "Vérification des zones pour {count} parcelles...",
      parcelsFound: "{count} parcelles trouvées"
    },
    siteFinder: {
      title: "Trouver des sites optimaux",
      searchPlaceholder: "Rechercher un numéro ou nom de municipalité…",
      loading: "Chargement des municipalités...",
      noResults: "Aucune municipalité trouvée",
      zones: "Zones",
      searching: "Recherche...",
      regionSelected: "✓ Région sélectionnée — recherche dans la vue cartographique actuelle",
      regionWarning: "⚠ Panoramique/zoom sur la carte pour définir la région",
      visibleRegion: "Région visible",
      currentMapView: "Vue cartographique actuelle",
      allNorway: "Toute la Norvège",
      areaRequired: "Surface requise",
      water: "Eau",
      necessary: "nécessaire",
      searchArea: "Zone de recherche",
      project: "Projet",
      technology: "Technologie",
      capacity: "Capacité",
      buffer: "Tampon",
      seawaterAccess: "Accès à l'eau de mer",
      requiredVoltage: "Tension requise",
      filters: "Filtres",
      maxGridDistance: "Distance max. au réseau",
      minVoltageLevel: "Niveau de tension min.",
      protectedDistance: "Distance de protection",
      portDistance: "Distance du port",
      portDepth: "Profondeur du port",
      waterDistance: "Distance de l'eau",
      terrain: "Terrain",
      maxElevation: "Altitude max.",
      maxSlope: "Pente max.",
      advancedFilters: "Filtres avancés",
      active: "actifs",
      hazardRisk: "Risque de glissement & inondation",
      biodiversity: "Biodiversité",
      all: "Tous",
      noFilter: "Aucun filtre",
      simple: "Simple",
      excludeOverlapping: "Exclure les zones chevauchantes",
      safe: "Sûr",
      fromZones: "des zones",
      strict: "Strict",
      noneWithin: "Aucun dans",
      searchButton: "Rechercher",
      stopSearch: "Arrêter",
      selected: "sélectionné",
      sortBy: "Trier par",
      score: "Score",
      gridDistance: "Distance au réseau",
      area: "Surface",
      results: "Résultats",
      noResultsFound: "Aucun résultat trouvé",
      selectAtLeastOne: "Sélectionnez au moins une municipalité ou utilisez 'Région visible' sur la carte",
      roadAccess: "Accès routier",
      roadQuality: "Qualité de la route",
      bridgeCapacity: "Capacité du pont",
      buildSeason: "Saison de construction",
      frostFreeMonths: "Saison de construction (mois sans gel/an)",
      waterRights: "Droits sur l'eau",
      noSalmon: "Pas de saumon",
      excludeSalmonRivers: "Exclure les rivières à saumon",
      lowConflict: "Faible conflit",
      noEndangered: "Pas d'espèces menacées",
      noRedListed: "Pas de liste rouge",
      municipalRoad: "Route municipale",
      municipalOrBetter: "Municipale ou mieux",
      countyRoad: "Route départementale",
      countyOrBetter: "Départementale ou mieux",
      nationalRoad: "E / Rv",
      nationalOnly: "Route nationale uniquement",
      notChecked: "Non vérifié",
      pavedRoads: "Routes goudronnées",
      electrolyzerDelivery: "Livraison d'électrolyseur",
      heavyTransport: "Transformateurs/transport lourd",
      inland: "Intérieur / nord",
      midNorway: "Centre-Norvège",
      coastSouth: "Côte / sud",
      months: "mois",
      oneKmFromZones: "≥1 km des zones",
      noneWithin2km: "Aucun dans 2 km",
      protectionPlan: "Plan de protection",
      excludeProtectedWaters: "Exclure les eaux protégées",
      noHydroCompetition: "+ pas de concurrence hydro",
      selectStation: "Sélectionner station",
      findZones: "Trouver des sites",
      findStations: "Trouver des stations",
      candidatesFound: "candidats trouvés",
      radius: "Rayon",
      suitableSitesFound: "sites appropriés trouvés",
      gridConnectionsFound: "connexions réseau trouvées",
      zoomToSeeParcels: "Zoomez sur la carte pour voir et sélectionner les parcelles",
      candidate: "Candidat",
      unknownStation: "Station inconnue",
      searchFailed: "Recherche échouée",
      analyzing: "Analyse des parcelles",
      fetchingData: "Récupération des données d'analyse",
      complete: "Terminé",
      noSitesLargeEnough: "Aucune parcelle n'était assez grande ou dans une zone appropriée dans le rayon de recherche.",
      noSitesMatchedCriteria: "Aucune parcelle ne correspondait à tous les critères.",
      sitesBlockedByHardStop: "parcelles ont atteint l'analyse, mais ont été bloquées par des arrêts durs.",
      tryIncreaseDistance: "Essayez d'augmenter la distance au réseau, de réduire l'exigence de tension ou de rechercher dans une autre zone."
    },
    mapControls: {
      changeMapStyle: "Changer le style de carte",
      layers: "Couches",
      mapStyle: "Style de carte",
      wmsLayers: "Couches WMS",
      showAll: "Tout afficher",
      hideAll: "Tout masquer",
      critical: "Critique",
      additional: "Supplémentaire"
    },
    analysis: {
      noAnalysisAvailable: "Aucune analyse de concession disponible",
      runAnalysisHint: "Cliquez sur 'Exécuter l'évaluation de concession' pour évaluer la probabilité d'approbation",
      disclaimer: "Cette évaluation est basée sur une analyse réglementaire et des données historiques. La probabilité d'approbation réelle peut varier. Consultez des experts juridiques et les autorités réglementaires.",
      loading: "Chargement...",
      gridCapex: "CAPEX Réseau",
      waterAssessment: "Évaluation de l'eau",
      lcohCalculator: "Calculateur LCOH",
      costEstimate: "Estimation des coûts",
      conceptComparison: "Comparaison de concepts"
    },
    common: {
      save: "Enregistrer",
      cancel: "Annuler",
      confirm: "Confirmer",
      close: "Fermer",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      search: "Rechercher",
      select: "Sélectionner",
      clear: "Effacer",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      done: "Terminé",
      edit: "Modifier",
      delete: "Supprimer",
      add: "Ajouter",
      remove: "Retirer",
      selected: "sélectionné",
      municipality: "Municipalité"
    }
  },
  it: {
    app: {
      title: "LandFalken",
      subtitle: "Ricerca intelligente dei siti",
      mySites: "I Miei Siti",
      signIn: "Accedi"
    },
    siteScreener: {
      title: "Selettore di Siti",
      loadingGrid: "Caricamento connessioni alla rete...",
      selectLocation: "Seleziona una posizione sulla mappa",
      searchPlaceholder: "Cerca una posizione...",
      zones: "Zone",
      municipalities: "Comuni",
      voltage: "Tensione",
      distance: "Distanza",
      operator: "Operatore",
      availableCapacity: "Capacità Disponibile",
      priceZone: "Zona di Prezzo",
      lcohLegend: "Indicazione LCOH",
      lcohDisclaimer: "*Stima approssimativa ±30%",
      showLcohMap: "Mostra mappa LCOH",
      drawMode: "Modalità disegno",
      endDrawMode: "Termina modalità disegno",
      drawPolygon: "Disegna poligono del sito",
      draw: "Disegna",
      drawnArea: "Area disegnata",
      zoomIn: "Zoom per vedere le particelle",
      zoomPrompt: "Zoom al livello 12 o superiore per vedere le particelle disponibili in quest'area",
      loadingParcels: "Caricamento particelle...",
      checkingZones: "Verifica zone per {count} particelle...",
      parcelsFound: "{count} particelle trovate"
    },
    siteFinder: {
      title: "Trova siti ottimali",
      searchPlaceholder: "Cerca numero o nome del comune…",
      loading: "Caricamento comuni...",
      noResults: "Nessun comune trovato",
      zones: "Zone",
      searching: "Ricerca in corso...",
      regionSelected: "✓ Regione selezionata — ricerca nella vista mappa attuale",
      regionWarning: "⚠ Sposta/zoom sulla mappa per definire la regione",
      visibleRegion: "Regione visibile",
      currentMapView: "Vista mappa attuale",
      allNorway: "Tutta la Norvegia",
      areaRequired: "Area richiesta",
      water: "Acqua",
      necessary: "necessario",
      searchArea: "Area di Ricerca",
      project: "Progetto",
      technology: "Tecnologia",
      capacity: "Capacità",
      buffer: "Margine",
      seawaterAccess: "Accesso all'acqua di mare",
      requiredVoltage: "Tensione richiesta",
      filters: "Filtri",
      maxGridDistance: "Distanza max. dalla rete",
      minVoltageLevel: "Livello min. di tensione",
      protectedDistance: "Distanza di protezione",
      portDistance: "Distanza dal porto",
      portDepth: "Profondità del porto",
      waterDistance: "Distanza dall'acqua",
      terrain: "Terreno",
      maxElevation: "Altitudine max.",
      maxSlope: "Pendenza max.",
      advancedFilters: "Filtri avanzati",
      active: "attivi",
      hazardRisk: "Rischio frane e alluvioni",
      biodiversity: "Biodiversità",
      all: "Tutti",
      noFilter: "Nessun filtro",
      simple: "Semplice",
      excludeOverlapping: "Escl. zone sovrapposte",
      safe: "Sicuro",
      fromZones: "dalle zone",
      strict: "Rigoroso",
      noneWithin: "Nessuno entro",
      searchButton: "Cerca",
      stopSearch: "Interrompi",
      selected: "selezionato",
      sortBy: "Ordina per",
      score: "Punteggio",
      gridDistance: "Distanza dalla rete",
      area: "Area",
      results: "Risultati",
      noResultsFound: "Nessun risultato trovato",
      selectAtLeastOne: "Seleziona almeno un comune, oppure usa 'Regione visibile' sulla mappa",
      roadAccess: "Accesso stradale",
      roadQuality: "Qualità della strada",
      bridgeCapacity: "Capacità del ponte",
      buildSeason: "Stagione di costruzione",
      frostFreeMonths: "Stagione di costruzione (mesi senza gelo/anno)",
      waterRights: "Diritti sull'acqua",
      noSalmon: "Nessun salmone",
      excludeSalmonRivers: "Escl. fiumi con salmoni",
      lowConflict: "Basso conflitto",
      noEndangered: "Nessuna specie a rischio",
      noRedListed: "Nessuna specie in lista rossa",
      municipalRoad: "Strada comunale",
      municipalOrBetter: "Comunale o superiore",
      countyRoad: "Strada provinciale",
      countyOrBetter: "Provinciale o superiore",
      nationalRoad: "Strada statale",
      nationalOnly: "Solo strada statale",
      notChecked: "Non verificato",
      pavedRoads: "Strade asfaltate",
      electrolyzerDelivery: "Consegna elettrolizzatore",
      heavyTransport: "Trasformatori/trasporti pesanti",
      inland: "Interno / nord",
      midNorway: "Norvegia centrale",
      coastSouth: "Costa / sud",
      months: "mesi",
      oneKmFromZones: "≥1 km dalle zone",
      noneWithin2km: "Nessuno entro 2 km",
      protectionPlan: "Piano di protezione",
      excludeProtectedWaters: "Escl. acque protette",
      noHydroCompetition: "+ nessuna concorrenza idroelettrica",
      selectStation: "Seleziona stazione",
      findZones: "Trova siti",
      findStations: "Trova stazioni",
      candidatesFound: "candidati trovati",
      radius: "Raggio",
      suitableSitesFound: "siti idonei trovati",
      gridConnectionsFound: "connessioni alla rete trovate",
      zoomToSeeParcels: "Esegui lo zoom sulla mappa per vedere e selezionare le particelle",
      candidate: "Candidato",
      unknownStation: "Stazione sconosciuta",
      searchFailed: "Ricerca non riuscita",
      analyzing: "Analisi particelle",
      fetchingData: "Recupero dati di analisi",
      complete: "Completato",
      noSitesLargeEnough: "Nessuna particella era abbastanza grande o in una zona idonea entro il raggio di ricerca.",
      noSitesMatchedCriteria: "Nessuna particella ha soddisfatto tutti i criteri.",
      sitesBlockedByHardStop: "particelle hanno raggiunto l'analisi, ma sono state bloccate da fattori di esclusione.",
      tryIncreaseDistance: "Prova ad aumentare la distanza dalla rete, ridurre il requisito di tensione, o cercare in un'altra area."
    },
    mapControls: {
      changeMapStyle: "Cambia stile mappa",
      layers: "Livelli",
      mapStyle: "Stile mappa",
      wmsLayers: "Livelli WMS",
      showAll: "Mostra tutto",
      hideAll: "Nascondi tutto",
      critical: "Critici",
      additional: "Aggiuntivi"
    },
    analysis: {
      noAnalysisAvailable: "Nessuna analisi di concessione disponibile",
      runAnalysisHint: "Clicca 'Esegui valutazione concessione' per valutare la probabilità di approvazione",
      disclaimer: "Questa valutazione si basa su analisi regolatorie e dati storici. La probabilità di approvazione effettiva può variare. Consultare esperti legali e autorità regolatorie.",
      loading: "Caricamento...",
      gridCapex: "CAPEX Rete",
      waterAssessment: "Valutazione Acqua",
      lcohCalculator: "Calcolatore LCOH",
      costEstimate: "Stima dei Costi",
      conceptComparison: "Confronto Concetti"
    },
    common: {
      save: "Salva",
      cancel: "Annulla",
      confirm: "Conferma",
      close: "Chiudi",
      loading: "Caricamento...",
      error: "Errore",
      success: "Successo",
      search: "Cerca",
      select: "Seleziona",
      clear: "Cancella",
      back: "Indietro",
      next: "Avanti",
      previous: "Precedente",
      done: "Fatto",
      edit: "Modifica",
      delete: "Elimina",
      add: "Aggiungi",
      remove: "Rimuovi",
      selected: "selezionato",
      municipality: "Comune"
    }
  }
};

export const useTranslation = (language) => {
  return (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || translations.en[keys[0]]?.[keys[1]] || key;
  };
};
